import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";

import type { SignalsState } from "./types";

const initialSignalsState: SignalsState = {
    appliedSignalsIds: [],
    shouldAutoApplyCreatedSignal: false,
    lastAutoAppliedCreatedSignal: null,
    isSignalsDescriptionBeingFetched: false,
    areSignalsBeingFetched: false,
    signalsById: {},
    signalsDescription: null,
    signalsBeingDeleted: [],
    signalDeleteErrorBySignalId: {},
    isSignalBeingUpdated: false,
    countPerSignalId: {},
    isCountPerSignalIdBeingFetched: false,
    isDropdownOpen: false,
    isSignalsManagementOpen: false,
    preselectedSignalType: null,
    preselectedAccountOverviewSignalType: null,
    initialSelectedSignalType: null,
    managementEditSignalId: null,
    managementDeleteSignalId: null,
    signalIdForHighlight: null,
    areSignalsAvailable: true,
    signalsSource: SignalSource.Platform,
};

export default initialSignalsState;
